import React, { useState } from 'react';
import { Typography, TextField, Button, Box, Stepper, Step, StepLabel, Paper, Grid,Card,CardActionArea, CardContent, Snackbar, Alert, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { CheckCircleOutline } from '@mui/icons-material';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'; // Leaflet stilleri
import { useTranslation } from "react-i18next";


const center = [40.8760, 29.3030]; // Şirketin gerçek koordinatlarıyla değiştirin
const Contact = () => {
  const { t } = useTranslation();

const categories = [
  {
    id:  t("categories.satinAlma.id"),
    label: t("categories.satinAlma.label"),
    description: t("categories.satinAlma.description"),
  },
  {
    id:  t("categories.kiralama.id"),
    label: t("categories.kiralama.label"),
    description: t("categories.kiralama.description"),
  },
  {
    id:t("categories.bizeUlasin.id"),
    label: t("categories.bizeUlasin.label"),
    description: t("categories.bizeUlasin.description"),
  },
];
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};


  const [activeStep, setActiveStep] = useState(0);
  const [category, setCategory] = useState('');
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '', category: '' });
  const [openSnackbar, setOpenSnackbar] = useState({ open: false, message: '', type: '' });
  const [loading, setLoading] = useState(false);

  const handleNext = () => setActiveStep((prevStep) => prevStep + 1);
  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);
  
  const handleCategorySelect = (selectedCategory) => {
    setCategory(selectedCategory);
    setFormData(prev => ({ ...prev, category: selectedCategory }));
  };

  const handleSubmit = async () => {
    // Form doğrulama
    if (!formData.name || !formData.email || !formData.message || !category) {
      setOpenSnackbar({ open: true, message: t('formMessages.fillAllFields'), type: 'error' });
      return;
    }

    const submissionData = { ...formData, category };

    setLoading(true);

    // E-posta doğrulaması
    if (!isValidEmail(formData.email)) {
      setOpenSnackbar({ open: true, message: t('formMessages.invalidEmail'), type: 'error' });
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post('https://www.remora.com.tr/wp-json/custom/v1/submit', submissionData);
      if (response.status === 200) {
        setOpenSnackbar({ open: true,  message: t('formMessages.successMessage'), type: 'success' });
        resetForm();
      }
    } catch (error) {
      // Hata mesajını daha detaylı göster
      console.error(t('formMessages.dataSendError', { error }));
      const errorMessage = error.response?.data || t('formMessages.sendError');
      setOpenSnackbar({ open: true, message: t('formMessages.emailError', { error: errorMessage }), type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({ name: '', email: '', subject: '', message: '', category: '' });
    setCategory('');
    setActiveStep(0);
  };
  

  return (
    <>
    <Paper elevation={10} sx={{ width: '100%', maxWidth: '1200px', margin: 'auto', padding: '4rem', borderRadius: '25px', backgroundColor: '#FFFFFF', color: '#333' }}>
      <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', textTransform: 'uppercase', color: '#333' }}>
      {t('contactSteps.title')}
      </Typography>
      <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
      <Step>
      <StepLabel>{t('contactSteps.step1')}</StepLabel>
    </Step>
    <Step>
      <StepLabel>{t('contactSteps.step2')}</StepLabel>
    </Step>
    <Step>
      <StepLabel>{t('contactSteps.step3')}</StepLabel>
    </Step>
      </Stepper>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        {activeStep === 0 && (
          <>
            <Typography variant="h5" align="center" gutterBottom sx={{ color: '#333' }}>
            {t('categories.selectCategory')}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
              <Grid container spacing={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                {categories.map((cat) => (
                  <Grid item xs={12} sm={6} key={cat.id}>
                    <Card sx={{ backgroundColor: category === cat.id ? '#00c6ff' : 'white', color: category === cat.id ? 'white' : 'black', textAlign: 'center', transition: '0.3s', border: category === cat.id ? '2px solid #00c6ff' : '1px solid #ddd', borderRadius: '15px', boxShadow: category === cat.id ? '0px 4px 10px rgba(0,0,0,0.2)' : '0px 2px 5px rgba(0,0,0,0.1)', '&:hover': { boxShadow: '0px 4px 12px rgba(0,0,0,0.3)' } }}>
                      <CardActionArea onClick={() => handleCategorySelect(cat.id)}>
                        <CardContent>
                          <Typography variant="h6" fontWeight="bold" sx={{ color: category === cat.id ? 'white' : 'black' }}>
                            {cat.label}
                          </Typography>
                          <Typography variant="body2" sx={{ color: category === cat.id ? 'white' : 'black' }}>
                            {cat.description}
                          </Typography>
                          {category === cat.id && <CheckCircleOutline sx={{ mt: 1, color: 'white' }} />}
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
            <Button variant="contained" disabled={!category} onClick={handleNext} sx={{ mt: 3, display: 'block', mx: 'auto', bgcolor: '#1976d2', color: 'white', '&:hover': { bgcolor: '#1565c0' }, borderRadius: '25px', padding: '12px 24px' }}>
            {t('contact2.continue')}
            </Button>
          </>
        )}
        {activeStep === 1 && (
          <>
            <TextField label={t('contact2.name')} variant="outlined" fullWidth name="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} margin="normal" />
            <TextField label={t('contact2.email')} variant="outlined" fullWidth name="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} margin="normal" />
            <TextField label={t('contact2.subject')} variant="outlined" fullWidth name="subject" value={formData.subject} onChange={(e) => setFormData({ ...formData, subject: e.target.value })} margin="normal" />
            <TextField label={t('contact2.message')} variant="outlined" fullWidth multiline rows={4} name="message" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} margin="normal" />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
              <Button variant="outlined" onClick={handleBack} sx={{ borderRadius: '25px', color: '#1976d2', borderColor: '#1976d2' }}>
              {t('contact2.back')}
              </Button>
              <Button variant="contained" onClick={handleNext} sx={{ bgcolor: '#1976d2', color: 'white', '&:hover': { bgcolor: '#1565c0' }, borderRadius: '25px', padding: '12px 24px' }}>
              {t('contact2.continue')}
              </Button>
            </Box>
          </>
        )}
        {activeStep === 2 && (
          <>
            <Typography variant="h5" align="center" gutterBottom sx={{ color: '#333', fontWeight: 'bold' }}>
            {t('contact2.selectedCategory')}: <span style={{ color: '#1976d2' }}>{category}</span>
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
              <Typography variant="h6" align="center"  gutterBottom sx={{ color: '#333', fontWeight: 'bold', }}>
                 {t('contact2.contactInfo')}
              </Typography>
              <Typography variant= "body1">{t('contact2.name')}:{formData.name} </Typography>
              <Typography variant="body1">{t('contact2.email')}: {formData.email}</Typography>
              <Typography variant="body1">{t('contact2.subject')}: {formData.subject}</Typography>
              <Typography variant="body1">{t('contact2.message')}: {formData.message}</Typography>
              </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button variant="outlined" onClick={handleBack} sx={{ borderRadius: '25px', color: '#1976d2', borderColor: '#1976d2' }}>
              {t('contact2.back')}
              </Button>
              <Button variant="contained" onClick={handleSubmit} disabled={loading} sx={{ bgcolor: '#1976d2', color: 'white', '&:hover': { bgcolor: '#1565c0' }, borderRadius: '25px', padding: '10px 20px' }}>
                {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : (
    t('contact2.submit') // t() fonksiyonu ile dil desteği eklenmiş
  )}
              </Button>
            </Box>
          </>
        )}
      </motion.div>
      </Paper>
   

      <Box 
  sx={{ 
    marginTop: '2rem', 
    p: 2, 
    width: '100%', 
    display: 'flex',  
    flexDirection: 'column',
    alignItems: 'center', 
    overflow: 'hidden',
    "@media (max-width: 600px)": {  
      flexDirection: 'column',  
      alignItems: 'center',
    }
  }}
>  
  {/* Başlık Kısmı */}
  <Typography  
    variant="h4"  
    sx={{  
      color: '#1976d2',  
      fontWeight: 'bold',  
      textAlign: 'center',  
      textTransform: 'uppercase',  
      marginBottom: '1rem',
    }}  
  >  
    {t('contact2.location')} 
  </Typography>  

  {/* Harita Kısmı */}
  <Box 
    sx={{ 
      width: '100%', 
      maxWidth: '1000px',
      "@media (max-width: 600px)": {  
        height: '400px',
        maxWidth: '100%',
      }
    }}
  >
    <MapContainer  
      center={center}  
      zoom={13}  
      style={{ height: '350px', width: '100%', borderRadius: '30px' }}
    >  
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />  
      <Marker position={center}>  
        <Popup>Remora Teknoloji</Popup>  
      </Marker>  
    </MapContainer>  
  </Box>
</Box>


  

      <Snackbar open={openSnackbar.open} autoHideDuration={6000} onClose={() => setOpenSnackbar({ open: false, message: '', type: '' })}>
        <Alert onClose={() => setOpenSnackbar({ open: false, message: '', type: '' })} severity={openSnackbar.type} sx={{ width: '100%' }}>
          {openSnackbar.message}
        </Alert>
      </Snackbar>
  </>



  );
};

export default Contact;
